"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m14.4749 3.1107 1.4142 1.4142-6.364 6.364L8.111 9.4747l6.364-6.364zm1.0606 7.4246c-.5858.5858-1.5355.5858-2.1213 0-.5858-.5858-.5858-1.5355 0-2.1213.5858-.5858 1.5355-.5858 2.1213 0 .5858.5858.5858 1.5355 0 2.1213zm-4.9497-4.9497c-.5858.5857-1.5355.5857-2.1213 0-.5858-.5858-.5858-1.5356 0-2.1214.5858-.5857 1.5355-.5857 2.1213 0 .5858.5858.5858 1.5356 0 2.1214zM2 21.0617l3.2142-.9642a.9993.9993 0 0 1 .5733-.0004l6.5851 1.9653a1.961 1.961 0 0 0 1.361-.0889l6.8702-3.0721A2.3593 2.3593 0 0 0 22 16.7475c0-1.5557-1.4793-2.6856-2.9802-2.2763l-2.8287.7715a2.386 2.386 0 0 0-1.9471-1.5286l-5.7816-.6979a2.285 2.285 0 0 0-1.1733.1682l-2.4448 1.0478a1 1 0 0 1-.745.0172L2 13.4622v2.136l1.397.5238a2.9999 2.9999 0 0 0 2.2351-.0515l2.4448-1.0478a.2834.2834 0 0 1 .1458-.0209l5.7817.6979a.3854.3854 0 0 1-.0462.768H10v2h3.9582c.8476 0 1.5804-.4384 2.0027-1.0892l3.5852-.9777a.3593.3593 0 0 1 .2412.6748l-6.8568 3.0661-6.571-1.9611a2.9996 2.9996 0 0 0-1.72.0012L2 18.9737v2.088z"
  })];
};

exports.default = _default;